/**
 * Component Registry for LPM Apartments
 * 
 * Inherits from @vibesites-weidner-apartment-homes/theme-weidner-classic-theme and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-weidner-apartment-homes/theme-weidner-classic-theme/registry';
import { Header } from './components/Header.tsx';
import { LuxuryDefinition } from './components/LuxuryDefinition.tsx';
import { Retailers } from './components/Retailers.tsx';
import { Footer } from './components/Footer.tsx';
import { NeighborhoodMap } from './components/NeighborhoodMap.tsx';
import { FloorplansList } from './components/FloorplansList.tsx';
import { TabbedCallouts } from './components/TabbedCallouts.tsx';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  LuxuryDefinition,
  Retailers,
  Footer,
  NeighborhoodMap,
  FloorplansList,
  TabbedCallouts,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
